import { APICore, setAuthorization } from './apiCore';

const api = new APICore();

function aamslogin(params: { email: string; password: string }) {
    const baseUrl = '/login';
    return api.create(`${baseUrl}`, params);
}

function login(params: { username: string; password: string }) {
    const baseUrl = '/login';
    return api.create(`${baseUrl}`, params);
}

function logout() {
    const baseUrl = '/logout';
    api.setLoggedInUser(null);
    setAuthorization(null);
    return api.create(`${baseUrl}`, {});
}

function signup(params: { fullname: string; email: string; password: string }) {
    const baseUrl = '/register';
    return api.create(`${baseUrl}`, params);
}

function forgotPassword(params: { username: string }) {
    const baseUrl = '/forget-password';
    return api.create(`${baseUrl}`, params);
}

function forgotPasswordConfirm(params: { email: string }) {
    const baseUrl = '/password/reset/confirm';
    return api.create(`${baseUrl}`, params);
}
function updateLicense(params: { email: string; licenseKey: string }) {
    const baseUrl = '/update-license';
    return api.create(`${baseUrl}`, params);
}

function validateLicense(params: { email: string; licenseKey: string }) {
    const baseUrl = '/validate-license';
    return api.create(`${baseUrl}`, params);
}

export { aamslogin, login, logout, signup, forgotPassword, forgotPasswordConfirm, updateLicense, validateLicense };
